import { db, DBEntity, SyncOperation, SyncQueueItem } from '@/shared/lib/db'
import { EntityTable } from 'dexie'


export abstract class BaseRepository<T> {

    abstract get(id: string): Promise<T | undefined>
    abstract getByKeys(keys: string[]): Promise<T[]>

    abstract getAll(filter?: (item: T) => boolean): Promise<T[]>

    abstract save(item: T, sync?: boolean): Promise<void>

    abstract delete(id: string, sync?: boolean): Promise<void>

    abstract queueSync(id: string, operation: SyncOperation, payload: any): Promise<void>


}



export abstract class BaseLocalRepository<T extends DBEntity> implements BaseRepository<T> {
    constructor(protected table: EntityTable<T, 'id'>, protected tableName: string) { }



    async get(id: string): Promise<T | undefined> {
        return this.table.get(id as any)
    }

    async getByKeys(keys: string[]): Promise<T[]> {
        return this.table.where('[projectId+title]').equals(keys).toArray()
    }


    async getAll(filter?: (item: T) => boolean): Promise<T[]> {
        if (filter) {
            return this.table.filter(filter).toArray()
        }
        return this.table.toArray()
    }

    async save(item: T, sync: boolean = true): Promise<void> {
        // Save to local DB
        await this.table.put(item)

        // Queue for sync
        if (sync) {
            await this.queueSync(item.id, 'UPDATE', item)
            // Note: 'UPDATE' covers both Create and Update in a "Last Write Wins" Put operation
        }
    }

    async delete(id: string, sync: boolean = true): Promise<void> {
        // Delete from local DB
        await this.table.delete(id as any)

        // Queue for sync
        if (sync) {
            await this.queueSync(id, 'DELETE', null)
        }
    }

    async queueSync(id: string, operation: SyncOperation, payload: any) {
        const syncItem: SyncQueueItem & { id: string } = {
            id: crypto.randomUUID(),
            entityTable: this.tableName,
            entityId: id,
            operation,
            payload,
            status: 'PENDING',
            retryCount: 0,
            created_at: new Date(),
            updated_at: new Date()
        }
        await db.sync_queue.add(syncItem)
    }

}
